import UsersContent from "../content/userContent";
import Layout from "../layout/Layout";

const Booking = () => {
  return (
    <Layout>
      <UsersContent />
    </Layout>
  );
};

export default Booking;
